import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {annotationFromStructure, queryTagRoute} from '../../../constants/public-routes';
import {TagBar} from '../../tags/components';
import Link from '../../routing/components/Link';
import {FormattedMessage} from 'react-intl';

const ArticleText = props => {
  let {article, params} = props;
  let tablerows = [];
  if (article.item.attributes) {
    let list = [article.item.attributes.content];
    while (list.length > 0) {
      let element = list.shift();
      if (element) {
        if (element.annotations.length > 0) {
          element.hasAnnotations = true;
        }
        element.children.map(child => child.hasAnnotations = element.hasAnnotations);
        tablerows.push(element);
        list = element.children.concat(list);
      }
    }
  }

  return (
    <div>
      <TagBar tags={article.item.attributes.tags} tagUrl={(tag) => {
        return queryTagRoute(params.lang, tag.value);
      }}/>
      <table className="articleTable">
        <tbody>
        {
          tablerows.map(element =>
            <tr key={element.id}>
              <td className={element.hasAnnotations ? "annotationCell" : "emptyAnnotationCell"}>
                <Link url={annotationFromStructure(params, element.id)}>
                  <div className={(element.annotations.length > 0 && 'annotationText')}>
                    {element.annotations.length > 0 && "Annot. " + element.label}
                  </div>
                </Link>
              </td>
              <td dangerouslySetInnerHTML={{__html: element.body}}/>
            </tr>
          )
        }
        </tbody>
      </table>
    </div>
  );
};

ArticleText.propTypes = {
  article: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired
};


function mapStateToProps(state) {
  const {article} = state;
  return {
    article
  };
}

export default connect(mapStateToProps)(ArticleText);



/** WEBPACK FOOTER **
 ** ./src/modules/articles/components/ArticleText.js
 **/